// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH

import { useState } from 'react';
import { Button } from '@/components/ui/button';
import EmailAuth from '../components/EmailAuth';
import { BookOpen, Rss, Search as SearchIcon, Edit3 } from 'lucide-react';

export const Login = () => {
  const [showEmailAuth, setShowEmailAuth] = useState(false);

  const handleGoogleLogin = () => {
    // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
    const redirectUrl = window.location.origin + '/dashboard';
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(
      redirectUrl
    )}`;
  };

  if (showEmailAuth) {
    return (
      <div className="min-h-screen bg-background">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
          <div className="text-center mb-8">
            <div className="flex justify-center mb-6">
              <BookOpen className="w-16 h-16 text-primary" strokeWidth={1.5} />
            </div>
            <h1 className="text-3xl md:text-4xl font-heading font-bold text-foreground mb-4">
              Blog Think About It
            </h1>
          </div>

          <EmailAuth />

          <div className="text-center mt-6">
            <button
              onClick={() => setShowEmailAuth(false)}
              className="text-primary hover:underline text-sm"
            >
              ← Voltar para opções de login
            </button>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-background">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="text-center max-w-3xl mx-auto">
          <div className="flex justify-center mb-8">
            <BookOpen className="w-20 h-20 text-primary" strokeWidth={1.5} />
          </div>

          <h1 className="text-4xl md:text-6xl font-heading font-bold text-foreground mb-6 tracking-tight leading-tight">
            Blog Think About It
          </h1>

          <p className="text-lg text-stone-700 leading-relaxed mb-12 max-w-2xl mx-auto">
            Agregue conteúdo de feeds RSS externos, crie seus próprios posts e gerencie tudo em um único lugar.
            Atualização automática a cada 1 hora.
          </p>

          <div className="space-y-4 mb-12">
            <Button
              onClick={handleGoogleLogin}
              size="lg"
              className="rounded-md px-8 py-6 text-lg shadow-lg hover:shadow-xl transition-all duration-300 w-full max-w-md"
              data-testid="google-login-button"
            >
              Entrar com Google
            </Button>

            <div className="flex items-center gap-4 max-w-md mx-auto">
              <div className="flex-1 border-t border-stone-300"></div>
              <span className="text-stone-500 text-sm">ou</span>
              <div className="flex-1 border-t border-stone-300"></div>
            </div>

            <Button
              onClick={() => setShowEmailAuth(true)}
              size="lg"
              variant="outline"
              className="rounded-md px-8 py-6 text-lg w-full max-w-md"
              data-testid="email-login-button"
            >
              Entrar com Email
            </Button>
          </div>

          <div className="mt-20 grid grid-cols-1 md:grid-cols-3 gap-8">
            <div className="text-center p-6">
              <div className="flex justify-center mb-4">
                <Rss className="w-12 h-12 text-primary" strokeWidth={1.5} />
              </div>
              <h3 className="text-xl font-heading font-semibold mb-3">Agregação RSS</h3>
              <p className="text-stone-600 leading-relaxed">
                Adicione feeds RSS e receba conteúdo atualizado automaticamente
              </p>
            </div>

            <div className="text-center p-6">
              <div className="flex justify-center mb-4">
                <Edit3 className="w-12 h-12 text-primary" strokeWidth={1.5} />
              </div>
              <h3 className="text-xl font-heading font-semibold mb-3">Posts Próprios</h3>
              <p className="text-stone-600 leading-relaxed">
                Crie e gerencie seus próprios artigos com facilidade
              </p>
            </div>

            <div className="text-center p-6">
              <div className="flex justify-center mb-4">
                <SearchIcon className="w-12 h-12 text-primary" strokeWidth={1.5} />
              </div>
              <h3 className="text-xl font-heading font-semibold mb-3">Busca Inteligente</h3>
              <p className="text-stone-600 leading-relaxed">
                Encontre conteúdo rapidamente com busca e categorização
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Login;